module.exports = __webpack_public_path__ + "static/img/player-pause.5c72076e.svg";